import {caretUpSvg as Icon__small__caretUpSvg} from '../Icon__small/Icon__small--caretUp.js';

export var caretUp = {
  name: 'caretUp',
  category: 'icon',
  colorable: true,
  svg: Icon__small__caretUpSvg,
};
